export class QueryController {
	constructor($location, searchService, uiConfig) {
		this.service = searchService;
		this.location = $location;
		this.keywords = searchService.getFilter('q').getValue();
		this.typingTimeout = uiConfig.typingTimeout;
	}

	update() {
		this.service.getFilter('q').setValue(this.keywords);

		let routerBuilder = this.service.getRouteBuilder();
		this.location.search(routerBuilder.getRoute());


		this.service.query();
	}
}

QueryController.$inject = ['$location', 'searchService', 'uiConfig'];